import styled, { css } from 'styled-components';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { mediaQuery } from 'src/app/styles/helper';

export const TextBlock = styled(Stack)`
  ${mediaQuery(
    'sm',
    css`
      justify-content: center;
    `
  )}
`;
